export const ABOUT_TOGGLE_PAUSED = "ABOUT_TOGGLE_PAUSED";
export const ABOUT_TOGGLE_MUTED = "ABOUT_TOGGLE_MUTED";
